import React from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';

const copy = {
  'no-assignment': {
    title: 'Aucune communauté assignée',
    body: "Vous n'avez pas encore de communauté attitrée. Contactez un administrateur pour obtenir l'accès à un espace HubUP.",
  },
  'empty-admin': {
    title: 'Aucune communauté',
    body: "Aucune communauté n'est disponible pour le moment sur la plateforme.",
  },
  mismatch: {
    title: 'Communautés introuvables',
    body: 'Les communautés associées à votre compte sont introuvables ou ont été retirées.',
  },
  error: {
    title: 'Chargement impossible',
    body: null,
  },
};

export default function HubupNoCommunityModal({
  variant,
  message,
  onRetry,
  onLogout,
}) {
  const cfg = copy[variant] || copy.error;
  const bodyText = variant === 'error' && message ? message : cfg.body;

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 p-4 overflow-y-auto overscroll-contain"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="hubup-no-community-title"
    >
      <div className="w-full max-w-md max-h-[min(90dvh,calc(100vh-2rem))] overflow-y-auto my-auto rounded-2xl bg-card border border-border shadow-elevation-3 p-6 space-y-4">
        <div className="flex justify-center">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <Icon name="UsersRound" size={24} className="text-primary" />
          </div>
        </div>
        <h2 id="hubup-no-community-title" className="text-center text-lg font-semibold text-foreground">
          {cfg.title}
        </h2>
        {bodyText && (
          <p className="text-sm text-center text-muted-foreground leading-relaxed">
            {bodyText}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
          {variant === 'error' && onRetry && (
            <Button type="button" variant="default" onClick={onRetry}>
              Réessayer
            </Button>
          )}
          <Button
            type="button"
            variant="outline"
            iconName="LogOut"
            onClick={onLogout}
          >
            Se déconnecter
          </Button>
        </div>
      </div>
    </div>
  );
}
